import FlowWithProvider from "../BuildNetwork/buildNetwork";

function BuildNetwork2({ info, setGame }) {
  return <FlowWithProvider info={info} setGame={setGame} />;
}

export default BuildNetwork2;
